var counter = 0;
var maxAttempts = 10;
var interval = 1000;

var labelsRender = document.querySelectorAll(
  "#RegisterForm .rendered-form label"
);

function callFunctionRepeatedly() {
  labelsRender = document.querySelectorAll(
    "#RegisterForm .rendered-form label"
  );
  var labels = document.querySelectorAll(
    "#RegisterForm .field label,#RegisterForm .rendered-form label"
  );
  var inputs = document.querySelectorAll(
    "#RegisterForm .field input,#RegisterForm .rendered-form input"
  );
  var filteredLabels = Array.from(labels).filter(
    (label) =>
      !(
        label.classList.contains("formbuilder-select-label") ||
        label.classList.contains("formbuilder-textarea-label") ||
        label.classList.contains("formbuilder-autocomplete-label")
      )
  );
  var filteredInputs = Array.from(inputs).filter(
    (input) => !input.classList.contains("country-field")
  );
  function updateLabelStyle(input, label) {
    if (input.value.trim() !== "" || input === document.activeElement) {
      label.style.top = "4px";
      label.style.fontSize = "10px";
      label.style.opacity = "0.8";

      input.style.padding = "20px 15px 5px 15px";
    } else {
      label.style.top = "11px";
      label.style.fontSize = "16px";
      label.style.opacity = "1";

      input.style.padding = "15px";
    }
  }
  filteredInputs.forEach((input, index) => {
    input.addEventListener("input", () =>
      updateLabelStyle(input, filteredLabels[index])
    );
    input.addEventListener("focus", () =>
      updateLabelStyle(input, filteredLabels[index])
    );
    input.addEventListener("blur", () =>
      updateLabelStyle(input, filteredLabels[index])
    );
  });

  function hideLabel(ele) {
    const label = ele.previousElementSibling;
    if (label) {
      if (ele.value.trim() !== "") {
        label.style.display = "none";
      } else {
        label.style.display = "unset";
      }
    }
  }
  const textAeras = document.querySelectorAll(".rendered-form textarea");
  if (textAeras.length) {
    textAeras.forEach((textAera) => {
      textAera.addEventListener("input", () => hideLabel(textAera));
      textAera.addEventListener("focus", () => hideLabel(textAera));
      textAera.addEventListener("blur", () => hideLabel(textAera));
    });
  }

  const textCountry = document.querySelector(".rendered-form .country-field");
  function styleForCoutryField(input) {
    const label = input.previousElementSibling;
    if (
      label &&
      input.nextElementSibling &&
      input.nextElementSibling.value.trim() !== ""
    ) {
      label.style.top = "4px";
      label.style.fontSize = "10px";
      label.style.opacity = "0.8";

      input.style.padding = "20px 15px 5px 15px";
    } else {
      label.style.top = "11px";
      label.style.fontSize = "16px";
      label.style.opacity = "1";

      input.style.padding = "15px";
    }
  }
  if (textCountry) {
    textCountry.addEventListener("input", () =>
      styleForCoutryField(textCountry)
    );
    textCountry.addEventListener("click", () =>
      setTimeout(() => {
        styleForCoutryField(textCountry);
      }, 100)
    );
    textCountry.addEventListener("blur", () =>
      setTimeout(() => {
        styleForCoutryField(textCountry);
      }, 200)
    );
  }

  if (labelsRender.length > 0 || counter >= maxAttempts) {
    console.log(inputs);
    console.log("Stopped calling function.");
    return;
  }
  counter++;
  setTimeout(callFunctionRepeatedly, interval);
}

document.addEventListener("DOMContentLoaded", function () {
  if (BSS_B2B) {
    callFunctionRepeatedly();
  }
});
